import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { HeaderLogo } from "./HeaderLogo";

export function AdminHeader() {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
        width: "100%",
      }}
    >
      <AppBar
        position="static"
        square
        color="transparent"
        sx={{
          py: { sm: 1, md: 2 },
          px: { sm: 2, md: 4 },
          width: "100%",
          background: "var(--mdai-background-header) !important",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            height: "76px",
            color: "#FFF",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "16px",
            fontStyle: "normal",
            lineHeight: "145%",
            letterSpacing: "-0.08px",
            maxWidth: 1280,
            width: "100%",
          }}
        >
          <HeaderLogo />
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography
              variant="body2"
              sx={{ color: "rgba(255,255,255,0.6)", whiteSpace: "nowrap" }}
            >
              Content Admin
            </Typography>
          </Stack>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
